module.exports = __webpack_public_path__ + "img/slider_galery_10.05b630cc.jpg";